export default __webpack_public_path__ + "static/media/Notification-34.f4e9ca25.png";